// extracted by mini-css-extract-plugin
module.exports = {"tabsHeaderContainer":"_2gs1T","tabsContainer":"_3MflN","tabs":"_2a-M4","icon":"_1uhml","indicator":"_3dXEW","description":"_1YKNp","tab":"_1NHqA","tabTitle":"_1ot0h"};